/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs */

const en_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy event from Group A to Group B`)
};

const fr_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier l'événement du groupe A vers le groupe B`)
};

const de_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis von Gruppe A nach Gruppe B kopieren`)
};

const it_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia l'evento dal Gruppo A al Gruppo B`)
};

const ru_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирование события из группы A в группу B`)
};

const es_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento del Grupo A al Grupo B`)
};

const zh_cn2_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 A 组的事件复制到 B 组`)
};

const ja_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループAからグループBにイベントをコピー`)
};

const hi_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ग्रुप A से ग्रुप B में इवेंट कॉपी करें`)
};

const pt_pt2_compare_event_groups_copy_event_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento do Grupo A para o Grupo B`)
};

/**
* | output |
* | --- |
* | "Copy event from Group A to Group B" |
*
* @param {Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_event_a_to_b_title = /** @type {((inputs?: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "de") return de_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "it") return it_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "ru") return ru_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "es") return es_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "ja") return ja_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "hi") return hi_compare_event_groups_copy_event_a_to_b_title(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_copy_event_a_to_b_title(inputs)
	return en_compare_event_groups_copy_event_a_to_b_title(inputs)
});